import { render, staticRenderFns } from "./CourseConfigration.vue?vue&type=template&id=607e519f"
import script from "./CourseConfigration.vue?vue&type=script&lang=js"
export * from "./CourseConfigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports